import { STORE_TYPES } from '../../config/tenantTypes';
import { supermarketMenu } from './menu';
import { supermarketRoutes } from './routes';

const SupermarketModule = {
  key: STORE_TYPES.SUPERMARKET,
  defaultPath: '/dashboard',
  menu: supermarketMenu,
  routes: supermarketRoutes,
};

export default SupermarketModule;
